import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { userService } from "../../../_services";
import { Badge } from "../../ui/badge";
import { Card } from "../../ui/card";

// Import modernized widgets
import BarWidget from '../BarWidget';
import ColumnPieWidget from '../ColumnPieWidget';
import MultiLineWidget from '../MultiLineWidget';
import ClaimWidget from '../Claim';
import TableWidget from '../TableWidget';
import MultiStackBarWidget from '../MultiStackBarWidget';

function AnalyticsPage() {
    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return moment(date).format("YYYYMMDD");
    });
    
    const [endDate, setEndDate] = useState(() => {
        return moment(new Date()).format("YYYYMMDD");
    });

    const [graphData, setGraphData] = useState([]);
    const [redirectToLogin, setRedirectToLogin] = useState(false);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            setRedirectToLogin(true);
            return;
        }

        const newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        loadGraphData();
    }, []);

    const loadGraphData = () => {
        const APIBaseURL = '/api/ws';
        const startDateStr = startDate;
        const endDateStr = endDate;

        const widgets = [
            {
                title: 'Total Transactions',
                url: `${APIBaseURL}/total_transactions_new`,
                RequestJson: JSON.stringify({
                    wname: "61",
                    wholesaler_id: "61",
                    start_date: startDateStr,
                    end_date: endDateStr,
                    rcount: 0,
                    chart_type: "columnList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    rxsClaimType: "totalpaid"
                }),
                type: 'bar',
                XlabelString: 'Date',
                YlabelString: 'Transactions'
            },
            {
                title: 'Transactions By Group Number',
                url: `${APIBaseURL}/Transactions_By_Group_Number`,
                RequestJson: JSON.stringify({
                    wname: "61",
                    start_date: startDateStr,
                    end_date: endDateStr,
                    rcount: 30,
                    chart_type: "columnList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    rxsClaimType: "totalpaid",
                    wholesaler_id: "61"
                }),
                type: 'bar',
                XlabelString: 'Group Number',
                YlabelString: 'Count'
            },
            {
                title: 'Unique Members',
                url: `${APIBaseURL}/Unique_Members_Widget`,
                RequestJson: JSON.stringify({
                    wname: "61",
                    start_date: startDateStr,
                    end_date: endDateStr,
                    rcount: 0,
                    chart_type: "columnList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    rxsClaimType: "totalpaid",
                    wholesaler_id: "61"
                }),
                type: 'bar',
                XlabelString: 'Date',
                YlabelString: 'Members'
            },
            {
                title: 'Drug Wise Transaction',
                url: `${APIBaseURL}/Drug_Wise_Transaction`,
                RequestJson: JSON.stringify({
                    wname: "61",
                    start_date: startDateStr,
                    end_date: endDateStr,
                    rcount: 30,
                    chart_type: "pielist",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    rxsClaimType: "totalpaid",
                    wholesaler_id: "61"
                }),
                type: 'columnpie',
                XlabelString: 'Drug',
                YlabelString: 'Count'
            }
        ];

        setGraphData(widgets);
    };

    const renderWidget = (widget, index) => {
        const commonProps = {
            key: index,
            title: widget.title,
            url: widget.url,
            requestJson: widget.RequestJson,
            startDate: startDate,
            endDate: endDate,
            xLabel: widget.XlabelString,
            yLabel: widget.YlabelString
        };

        switch (widget.type) {
            case 'bar':
                return <BarWidget {...commonProps} />;
            case 'columnpie':
                return <ColumnPieWidget {...commonProps} />;
            case 'multiline':
                return <MultiLineWidget {...commonProps} />;
            case 'table':
                return <TableWidget {...commonProps} />;
            case 'multistack':
                return <MultiStackBarWidget {...commonProps} />;
            default:
                return null;
        }
    };

    if (redirectToLogin) {
        return <Navigate to="/Login" />;
    }

    return (
        <div className="p-6 space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold text-brand-dark">Analytics</h1>
                    <p className="text-brand-dark/70 mt-1">View detailed analytics and insights</p>
                </div>
                <Badge className="bg-brand-accent text-white uppercase hover:bg-brand-accent">
                    Beta
                </Badge>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                {graphData.map((widget, index) => (
                    <Card key={index} className="p-0">
                        {renderWidget(widget, index)}
                    </Card>
                ))}
            </div>
        </div>
    );
}

export default AnalyticsPage;
